import { render, staticRenderFns } from "./InputLottery.vue?vue&type=template&id=fe4d70aa&scoped=true"
import script from "./InputLottery.vue?vue&type=script&lang=js"
export * from "./InputLottery.vue?vue&type=script&lang=js"
import style0 from "./InputLottery.vue?vue&type=style&index=0&id=fe4d70aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4d70aa",
  null
  
)

export default component.exports